import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class SupersetService {
  private baseUrl = 'http://localhost:8088/api/v1';
  private accessToken: string | null = null;

  constructor(private http: HttpClient) {}

  async login(username: string, password: string): Promise<void> {
    const res: any = await this.http.post(`${this.baseUrl}/security/login`, {
      username,
      password,
      provider: 'db',
      refresh: true
    }).toPromise();

    this.accessToken = res.access_token;
  }

  private get headers(): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`
    });
  }

  async getChartData(chartId: number): Promise<any> {
    const url = `${this.baseUrl}/chart/${chartId}/data`;
    return this.http.post(url, {}, { headers: this.headers }).toPromise();
  }
}
